import { render } from "./ExportInterfaceForm.vue?vue&type=template&id=40ddee0f&scoped=true&ts=true"
import script from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"
export * from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"

import "./ExportInterfaceForm.vue?vue&type=style&index=0&id=40ddee0f&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ddee0f"]])

export default __exports__